import React from 'react'
import styled from 'styled-components'
import { transparentize, shade } from 'polished'
import { Card, Link, Text } from 'adl'

const BG = styled(Card)`
  background-image: url(${props => props.image});
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  min-height: 4rem;
  min-width: 4rem;
  background-color: ${props => props.theme.colors.gray800};

  &::before {
    background: linear-gradient(
      to bottom,
      ${props =>
        transparentize(0.5, shade(0.75, props.theme.colors.interactive))},
      ${props =>
        transparentize(0.3, shade(0.75, props.theme.colors.interactive))}
    );
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
  }
`

const Title = styled.div`
  color: white;
  font-weight: bold;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  text-align: center;

  @media only screen and (max-width: 450px) {
    font-size: 1.5rem;
  }
`

const BodyText = styled(Text)`
  color: ${props => props.theme.colors.gray100};
  font-size: 1.5rem;
  text-align: center;
  margin-bottom: 0;

  @media only screen and (max-width: 450px) {
    font-size: 1rem;
  }
`

const TheLink = styled(Link)`
  display: block;
  color: white;
  margin-left: auto;
  text-align: right;
`

const defaultData = {
  title: 'Cha-ching into spring',
  body: 'Take advantage of our HELOC special!',
  linkText: 'Learn More',
  image: require('images/marketing/house.jpg')
}

const MarketingTile = ({ title, body, image, linkText, ...rest }) => (
  <BG {...rest} image={image} elevation={2}>
    <Card.Body style={{ position: 'relative' }}>
      <Title>{title}</Title>
      <BodyText>{body}</BodyText>
      <TheLink>
        {linkText} <i className="icon-chevron-right" />
      </TheLink>
    </Card.Body>
  </BG>
)

MarketingTile.defaultProps = {
  title: defaultData.title,
  body: defaultData.body,
  image: defaultData.image,
  linkText: defaultData.linkText
}

export default MarketingTile
